export const properties = [
  {
    idProperty: 1,
    idUser: 12,
    description:
          'Promoción de Obra nueva situada en Barcelona, exclusiva promoción de 22 viviendas con acabados de primera calidad, sistema de climatización de aerotermia de ahorro energético, suelos de parqué, piso de 90,30m² construidos, 2 habitaciones dobles y 1 individual, 2 baños completos, cocina independiente con salida al balcón, amplio comedor con salida al balcón, con parking opcional ! Ven a pedir bookingrmación !',
    city: 'Barcelona',
    province: 'Barcelona',
    address: 'Carrer del Riu',
    zipCode: '08480',
    number: 9,
    type: 'piso',
    stair: '0',
    elevator: null,
    flat: 1,
    gate: '3',
    mts: '90.00',
    rooms: 3,
    garage: 0,
    terrace: 0,
    toilets: 2,
    energyCertificate: 0,
    availabilityDate: '2021-11-10T00:00:00.000Z',
    price: '650.00',
    state: 'disponible',
    votes: '3.0000',
    createdAt: '2021-11-10T19:26:11.000Z'
  },
  {
    idProperty: 2,
    idUser: 12,
    description:
          'Últimos apartamentos en nuestra promoción Santa Clara 11.Se encuentra instalada en una de las mejores zonas del casco antiguo de Girona, frente al río Onyar. El objetivo de Zenit Houses es transformar el edificio denso de oficinas de los años 70 en una nueva tipología de vida dinámica. Se propone un nuevo patio de luces. Se piensa como un espacio moderno, transparente y luminoso, abierto al cielo. Como corazón de construcción, proporciona luz, ventilación y carácter a las viviendas y al público. Se define en bloques de vidrio siguiendo la tradición de la galería norte-europea, tal como sucede en la Viennese Otto Wagner modernist DS. Las tipologías de viviendas variadas están abiertas tanto en la calle como en el patio. Los diferentes niveles están ocupados con múltiples experiencias de vida. La antigua estructura flexible se adapta a los nuevos tiempos, y también desarrolla una nueva fachada en la calle, que muestra el carácter renovado de Girona. Los apartamentos están listos para entrar a vivir, cocinas totalmente completas con los electrodomésticos integrados incluidos.',
    city: 'Girona',
    province: 'Girona',
    address: 'Carrer de Costa Rica',
    zipCode: '17001',
    number: 9,
    type: 'duplex',
    stair: '1',
    elevator: 1,
    flat: 2,
    gate: '2',
    mts: '85.00',
    rooms: 2,
    garage: 0,
    terrace: 0,
    toilets: 1,
    energyCertificate: 0,
    availabilityDate: '2021-11-10T00:00:00.000Z',
    price: '300.00',
    state: 'disponible',
    votes: '0.0000',
    createdAt: '2021-11-10T19:26:11.000Z'
  },
  {
    idProperty: 3,
    idUser: 13,
    description:
          'El piso está reformado y se encuentra en ÓPTIMAS CONDICIONES. Cuenta con CALEFACCIÓN CENTRAL INCLUIDA EN EL PRECIO. Tiene aire acondicionado en el salón Es EXTERIOR.\nTiene techos altos, paredes lisas con molduras de techo, suelos de parqué. Cuenta con puerta blindada y ventilación cruzada. Podemos encontrar ARMARIOS EMPOTRADOS en dos dormitorios. Las ventanas son climalit. Se divide en las siguientes estancias: -Hall de entrada: Recibidor que da acceso a la vivienda -Salón: con ventanas exteriores. La zona de comedor es independiente. -Cocina: Independiente, amueblada y equipada con ELECTRODOMÉSTICOS. Cuenta con HORNO, microondas, LAVAVAJILLAS, HORNO, y vitrocerámica. Tiene ventana. -Zona office que da servicio a la cocina -Zona de lavadero, independiente, con su puerta de servicio -Dormitorio 1: MATER BEDROOM, con baño ensuite. Tiene ventana exterior. Acceso desde el salón -Baño 1: Con bañera -Dormitorio 2: INDIVIDUAL, con baño ensuite. Tiene ventana interior -Baño 2: Con pie de ducha -Dormitorio 3: de SERVICIO. Tiene ventana -Baño 3: Con ducha. Tiene ventana',
    city: 'Madrid',
    province: 'Madrid',
    address: 'Calle Aragón',
    zipCode: '28002',
    number: 9,
    type: 'piso',
    stair: '1',
    elevator: null,
    flat: 3,
    gate: '2',
    mts: '80.00',
    rooms: 1,
    garage: 0,
    terrace: 0,
    toilets: 1,
    energyCertificate: 0,
    availabilityDate: '2021-11-10T00:00:00.000Z',
    price: '1250.00',
    state: 'disponible',
    votes: '3.0000',
    createdAt: '2021-11-10T19:26:11.000Z'
  },
  {
    idProperty: 4,
    idUser: 13,
    description:
          'El piso está reformado y se encuentra en ÓPTIMAS CONDICIONES. Cuenta con CALEFACCIÓN CENTRAL INCLUIDA EN EL PRECIO. Tiene aire acondicionado en el salón Es EXTERIOR.\nTiene techos altos, paredes lisas con molduras de techo, suelos de parqué. Cuenta con puerta blindada y ventilación cruzada. Podemos encontrar ARMARIOS EMPOTRADOS en dos dormitorios. Las ventanas son climalit. Se divide en las siguientes estancias: -Hall de entrada: Recibidor que da acceso a la vivienda -Salón: con ventanas exteriores. La zona de comedor es independiente. -Cocina: Independiente, amueblada y equipada con ELECTRODOMÉSTICOS. Cuenta con HORNO, microondas, LAVAVAJILLAS, HORNO, y vitrocerámica. Tiene ventana. -Zona office que da servicio a la cocina -Zona de lavadero, independiente, con su puerta de servicio -Dormitorio 1: MATER BEDROOM, con baño ensuite. Tiene ventana exterior. Acceso desde el salón -Baño 1: Con bañera -Dormitorio 2: INDIVIDUAL, con baño ensuite. Tiene ventana interior -Baño 2: Con pie de ducha -Dormitorio 3: de SERVICIO. Tiene ventana -Baño 3: Con ducha. Tiene ventana',
    city: 'Madrid',
    province: 'Madrid',
    address: 'Calle Aragón',
    zipCode: '28002',
    number: 9,
    type: 'piso',
    stair: '1',
    elevator: null,
    flat: 3,
    gate: '2',
    mts: '80.00',
    rooms: 1,
    garage: 0,
    terrace: 0,
    toilets: 1,
    energyCertificate: 0,
    availabilityDate: '2021-11-10T00:00:00.000Z',
    price: '1250.00',
    state: 'disponible',
    votes: '3.0000',
    createdAt: '2021-11-10T19:26:11.000Z'
  }
]
